/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';

export const createUrl = (filterId: string): string => `/rest/agile/1.0/board/filter/${filterId}`;

const getBoards = (
	filterId: string,
): Promise<{
	values: [];
}> => fetchJson(createUrl(filterId));

export default getBoards;
